import { StyleSheet } from "react-native";
export function getStylePropValue(styles, propName) {
    return StyleSheet.flatten(styles)[propName];
}
